import React from 'react'

export default function Restore() {
    return (
        <div>
            RESTORE JS
        </div>
    )
}
